<header tuiNavigationHeader>
  <app-main-page-navbar class="w-full"></app-main-page-navbar>
</header>

<main
  tuiNavigationMain
  class="block">
  <app-hero-section></app-hero-section>
</main>
